import { SlotProps } from "input-otp";
import { cn } from "@/lib/utils";

export function Slot(props: SlotProps) {
	return (
		<div
			className={cn(
				"yF-relative yF-w-10 yF-h-11 yF-text-[1.8rem]",
				"yF-flex yF-items-center yF-justify-center",
				"yF-transition-all yF-duration-300 yF-ring-1 yF-ring-[--yF-theme-color]",
				"yF-border yF-rounded-md",
				"yF-outline yF-outline-0 yF-outline-[--yF-theme-color]",
				{
					"yF-outline-2 yF-outline-[--yF-theme-color]":
						props.isActive,
				}
			)}
		>
			{props.char !== null && <div>{props.char}</div>}
			{props.hasFakeCaret && <FakeCaret />}
		</div>
	);
}

function FakeCaret() {
	return (
		<div className="yF-absolute yF-pointer-events-none yF-inset-0 yF-flex yF-items-center yF-justify-center yF-animate-caret-blink">
			<div className="yF-w-px yF-h-8 yF-bg-white" />
		</div>
	);
}

export function FakeDash() {
	return (
		<div className="yF-flex yF-w-10 yF-justify-center yF-items-center">
			<div className="yF-w-3 yF-h-1 yF-rounded-full yF-bg-border yF-bg-[--yF-theme-color]" />
		</div>
	);
}
